module.exports = __webpack_public_path__ + "img/scheduled-blue.c7446473.svg";